import { isAdvancedCalcSupported } from '../utilities/helpers'

export default {
  bind: function(el) {
    el.classList.add(
      isAdvancedCalcSupported() ? `js-advanced-calc` : `js-no-advanced-calc`
    )
  },
}
